import { ChevronDown as ChevronDownSVG } from '~components';
import * as Styled from './styled';

import { Props } from './types';
import { PersonInformation } from './sections';
import { useState } from 'react';

function RepresentativeCard({ representative, onboardingStatus }: Props) {
  const [isOpenAccordion, setIsOpenAccordion] = useState(false);

  const handleOpen = () => {
    setIsOpenAccordion(!isOpenAccordion);
  };

  return (
    <Styled.OutlinedCard>
      <Styled.ChevronDown
        onClick={handleOpen}
        aria-label="Open"
        isOpenAccordion={isOpenAccordion}
      >
        <ChevronDownSVG />
      </Styled.ChevronDown>

      <Styled.PersonContainer>
        <PersonInformation
          id={representative.id}
          name={representative.name}
          status={representative.status}
          type="representative"
          showChecklistIncolumns={!representative.spouse}
          showChecklist={isOpenAccordion}
          canSendSMS={
            ['documents-collect', 'documents-validation'].includes(
              onboardingStatus
            ) && !['done', 'validation'].includes(representative.status)
          }
          documents={representative.documents}
        />

        {representative.spouse && (
          <PersonInformation
            id={representative.spouse.id}
            name={representative.spouse.name}
            status={representative.spouse.status}
            type="spouse"
            showChecklist={isOpenAccordion}
            canSendSMS={
              ['documents-collect', 'documents-validation'].includes(
                onboardingStatus
              ) &&
              !['done', 'validation'].includes(representative.spouse.status)
            }
            documents={representative.spouse.documents}
          />
        )}
      </Styled.PersonContainer>
    </Styled.OutlinedCard>
  );
}

export default RepresentativeCard;
